export enum RelationType{

    Empty = 0,

    /**
     * ä¸
     */
    // And=0,
    And = 1,

    /**
     * æ
     */
    // Or=1
    Or = 2
}